import * as _ from 'lodash'
import React from 'react';
import globalRelay from '../globalRelay';
import valueFilters from '../valueFilters';
import keyboardUtil from '../keyboardUtils';
import { CurrencyInput, Header, jobCostRowOwner, JobCostHiddenWhenLocked } from './sharedComponents';

const _jobCostLineItemTypes = [{ name: 'referral-fee' }];
const KEY_DOWN_CODES = [13];

class JobCostReferralFeeRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { shouldValidate: props.alwaysValidate };

		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.updateModel = this.updateModel.bind(this);
	}

	updateModel (path, autoSave, e) {
		const { referralFeeConfig } = this.props;
		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		this.props.updateModel((model, updateCallback) => {
			model.setAt(path, newVal);

			if (path === 'subType') {
				const subTypeConfig = referralFeeConfig.subTypes[newVal];

				model.isPreSubtotal = !!subTypeConfig && subTypeConfig.isPreSubtotal;
			}

			updateCallback(model, path);
		}, { autoSave: autoSave });
	}

	validate (property?) {
		if (!property || this.state.shouldValidate) {
			const result = !this.props.lineItem.test(property);

			return result;
		}
		return true;
	}

	handleButtonClick (e) {
		e.preventDefault();

		const valid = this.isValidForm();
		this.props.buttonHandler(valid, e);
	}

	isValidForm() {
		const valid = this.validate();

		if (!valid) {
			this.setState({ shouldValidate: true });
		}
		else {
			// this assumes that the add handler succeeds
			this.setState({ shouldValidate: this.props.alwaysValidate });
		}
		return valid;
	}

	render () {
		const { classNames = [], buttonClass, lineItem, referralFeeConfig = [] } = this.props;
		const rowClasses = _.concat(classNames);
		const subTypeOptions = _.map(referralFeeConfig.subTypes, (config, key) => <option key={ key } value={ key }>{ config.label }</option>);
		const paymentMethodOptions = _.map(referralFeeConfig.paymentMethods, (value, key) => <option key={ key } value={ key }>{ value }</option>);

		subTypeOptions.unshift(<option key={ 'empty' } value="">Select</option>);
		paymentMethodOptions.unshift(<option key={ 'empty' } value="">Select</option>);

		return (<tr className={rowClasses.join(' ')} >
			<td />
			<td>
				<select placeholder="Select" value={lineItem.viewValue('subType')} onChange={this.updateModel.bind(this, 'subType', true)}>
					{ subTypeOptions }
				</select>
			</td>
			<td className={'cost ' + ' ' + (!this.validate('cost') ? 'required' : '')}>
				<CurrencyInput placeholder="0.00" value={lineItem.viewValue('cost')} 
					onChange={this.updateModel.bind(this, 'cost', false)} 
					onBlur={this.updateModel.bind(this, 'cost', true)}
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => this.handleButtonClick(e))}/>
			</td>
			<td>
				<select placeholder="Select" value={lineItem.viewValue('orderNote')} onChange={this.updateModel.bind(this, 'orderNote', true)}>
					{ paymentMethodOptions }
				</select>
			</td>
			<td className={' ' + (!this.validate('description') ? 'name required' : 'name')}>
				<input type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" 
					value={lineItem.viewValue('description')} 
					onChange={this.updateModel.bind(this, 'description', false)} 
					onBlur={this.updateModel.bind(this, 'description', true)} 
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => this.handleButtonClick(e))}/>
			</td>
			<td className={' ' + (!this.validate('itemNote') ? 'required' : '')}>
				<input type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" 
					value={lineItem.viewValue('itemNote')} onChange={this.updateModel.bind(this, 'itemNote', false)} 
					onBlur={this.updateModel.bind(this, 'itemNote', true)} 
					onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => this.handleButtonClick(e))}/>
			</td>
			<td><button className={buttonClass} onClick={this.handleButtonClick}><span /></button></td>
			<td />
		</tr>);
	}
}

const JobCostReferralFeeSection = jobCostRowOwner({ listAccessor: model => model.lineItems, listFilterThunkFactory: props => row => row.type === props.type }, class ReferralSection extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);
	}

	getStateFromProps (props) {
		const state = _.assign({}, this.state);

		if (!state.pendingLineItem || state.pendingLineItem.type !== props.type) {
			state.pendingLineItem = this.createPendingLineItem(props);
		}

		return state;
	}

	addLineItemHandler (lineItemKey, isValid) {
		if (!isValid) {
			return;
		}

		this.props.updateModel(model => {
			if (lineItemKey === this.state.pendingLineItem.key) {
				this.state.pendingLineItem.sortIndex = this.props.getNextSortIndex(model);
				model.lineItems.add(this.state.pendingLineItem);

				this.props.sortRows(model);

				this.setState({ pendingLineItem: this.createPendingLineItem(this.props) });
			}
		}, { autoSave: true });
	}

	createPendingLineItem (props) {
		const { jobCost, type } = props;
		return jobCost.createLineItem({ type: type, margin: 0 });
	}

	printHandler () {
		// does nothing
	}

	updateModel (key, updater, options) {
		this.props.updateModel((jobCost, lineUpdateCallback) => {
			let lineItem = jobCost.lineItems.get(key);

			if ((!lineItem) && (key === this.state.pendingLineItem.key)) {
				lineItem = this.state.pendingLineItem;
				options.autoSave = false;
			}

			if (lineItem) {
				updater(lineItem, lineUpdateCallback);
			}
		}, options);
	}

	render () {
		const { getRowClasses, jobCost, type, rowContextMenuHandler } = this.props;
		const globalConfig = globalRelay.config!.withVariant(jobCost.companyVariant);
		const referralFeeConfig = globalConfig.jobCostSettings.referralFee;
		const lineItems = _.map(_.sortBy(jobCost.getLineItemsByType(type), 'sortIndex'), item => {
			return (
				<JobCostReferralFeeRow key={item.rowKey} updateModel={this.updateModel.bind(this, item.key)} buttonHandler={ rowContextMenuHandler.bind(this, item) } lineItem={item} classNames={ getRowClasses({ item: item }) } buttonClass="icon iconOnly contextMenu" workAreas={jobCost.workAreas} alwaysValidate={true} referralFeeConfig={ referralFeeConfig }/>
			);
		});

		return (
			<section>
				<header />
				<div className="inner">

					<table className="compact" cellPadding="0" cellSpacing="0">
						<thead>
							<tr>
								<td />
								<td><span className="readOnly">Type</span></td>
								<td className="cost"><span className="readOnly">Amount</span></td>
								<td><span className="readOnly">Payment Method</span></td>
								<td><span className="readOnly">Recipient</span></td>
								<td><span className="readOnly">Contact Info</span></td>
								<td className="action" />
								<td />
							</tr>
						</thead>
						<tbody>
							<JobCostHiddenWhenLocked jobCost={ jobCost }><JobCostReferralFeeRow key={this.state.pendingLineItem.key} updateModel={this.updateModel.bind(this, this.state.pendingLineItem.key)} buttonHandler={this.addLineItemHandler.bind(this, this.state.pendingLineItem.key)} lineItem={this.state.pendingLineItem} classNames={ ['addRow'] } buttonClass="icon iconOnly addItem" referralFeeConfig={ referralFeeConfig } /></JobCostHiddenWhenLocked>
							{ lineItems }
						</tbody>
					</table>
				</div>
			</section>
		);
	}
});

export default ({ jobCost = undefined, summary = undefined, updateModel = undefined }) => {
	const sections = _.map(_jobCostLineItemTypes, type => {
		return (
			<JobCostReferralFeeSection key={type.name} updateModel={updateModel} jobCost={jobCost} summary={ summary } type={type.name} />
		);
	});

	return (
		<section>
			<Header title="Referral Fee"/>
			<div>
				{sections}
			</div>
		</section>

	);
};